export const download = (fileName, data) => {
  console.log('L82----->', data.length);
  var pom = document.createElement('a');
  pom.setAttribute(
    'href',
    'data:text/csv;charset=utf-8,' + encodeURIComponent(data),
  );
  pom.setAttribute('download', fileName);

  if (document.createEvent) {
    var event = document.createEvent('MouseEvents');
    event.initEvent('click', true, true);
    pom.dispatchEvent(event);
  } else {
    pom.click();
  }

  return true;
};
